/*
 * Ranking por tienda y por zona (según la tienda ACTUAL de cada persona): puntualidad, asistencia, horas
 * por persona al día e incompletas, con un botón para cambiar de agrupación. Consume `por_tienda` y
 * `por_zona` de /attendance/dashboard/: ya vienen ordenados por puntualidad (los sin dato al final); las
 * personas sin tienda/zona llegan en el grupo "Sin asignar" con id null. Un valor null se muestra "—",
 * nunca 0 (y sin barra). Los textos salen de groupLine/barWidth (utils/dashboard.js, con pruebas); asistencia
 * y horas van en texto neutro y solo "incompletas" se resalta (insignia) cuando es mayor que 0.
 */
import React, {useState} from "react";
import StatusBadge from "../../components/StatusBadge";
import {barWidth, groupLine} from "../../utils/dashboard";

const GROUPS = [
    {key: 'tienda', label: 'Por tienda', rowsKey: 'por_tienda', idKey: 'id_tienda'},
    {key: 'zona', label: 'Por zona', rowsKey: 'por_zona', idKey: 'id_zona'},
];

const GroupsPanel = ({datos}) => {
    const [groupKey, setGroupKey] = useState('tienda');
    const group = GROUPS.find((item) => item.key === groupKey);
    const rows = datos[group.rowsKey] || [];
    return (
        <div className="mc-panel">
            <h3 className="mc-panel__title">Tiendas y zonas</h3>
            <p className="mc-panel__hint">Según la tienda actual de cada persona, de mayor a menor puntualidad.</p>
            <div className="mc-toggle" role="group" aria-label="Agrupar por">
                {GROUPS.map((item) => (
                    <button key={item.key} type="button" aria-pressed={groupKey === item.key}
                            className={`mc-toggle__item${groupKey === item.key ? ' is-active' : ''}`}
                            onClick={() => setGroupKey(item.key)}>
                        {item.label}
                    </button>
                ))}
            </div>
            {rows.length === 0 ? <p className="mc-inline-empty">Sin datos en este rango.</p> : (
                <ol className="mc-list mc-list--ranked">
                    {rows.map((row) => {
                        const line = groupLine(row);
                        const id = row[group.idKey];
                        return (
                            <li key={`${group.key}-${id === null || id === undefined ? 'sin-asignar' : id}`}
                                className="mc-list__item mc-list__item--group"
                                aria-label={`${row[group.key]}: puntualidad ${line.puntualidad === '—' ? 'sin dato' : line.puntualidad}`}>
                                <span className="mc-person">
                                    <span className="mc-person__name">{row[group.key]}</span>
                                    <span className="mc-person__meta">{line.meta}</span>
                                </span>
                                <span className="mc-list__time mc-num">
                                    {line.puntualidad}
                                    <small>puntualidad</small>
                                </span>
                                <span className="mc-group__bar" aria-hidden="true">
                                    {barWidth(row.puntualidad) > 0 && <span style={{width: `${barWidth(row.puntualidad)}%`}}/>}
                                </span>
                                <span className="mc-group__stats">
                                    <span>Asistencia <strong className="mc-num">{line.asistencia}</strong></span>
                                    <span><strong className="mc-num">{line.horas}</strong> por día</span>
                                    {line.incompletas && <StatusBadge tone="down" text={line.incompletas}/>}
                                </span>
                            </li>
                        );
                    })}
                </ol>
            )}
        </div>
    );
};

export default GroupsPanel;
